import type { StoreSocialLinks } from '../services/storeService'

const SOCIAL_LINK_KEYS = ['instagram', 'facebook', 'x', 'website', 'whatsapp'] as const

/** Normalise API/DB social_links (object or accidental JSON string). */
export function coerceStoreSocialLinks(raw: unknown): StoreSocialLinks {
  if (raw == null) return {}
  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (!trimmed) return {}
    try {
      return coerceStoreSocialLinks(JSON.parse(trimmed) as unknown)
    } catch {
      return {}
    }
  }
  if (typeof raw !== 'object' || Array.isArray(raw)) return {}
  const obj = raw as Record<string, unknown>
  const out: StoreSocialLinks = {}
  for (const key of SOCIAL_LINK_KEYS) {
    const v = obj[key]
    if (typeof v === 'string' && v.trim()) out[key] = v.trim()
  }
  return out
}
